var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSkip)?_c('iframe',{attrs:{"id":"iframeName","src":_vm.visualSrc,"frameborder":"0","width":"100%","height":_vm.height}}):_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},style:({'height': _vm.height + 'px'})},[_c('span',[_vm._v(_vm._s(_vm.info))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }